module.exports = __webpack_public_path__ + "img/scanatic.11b4fa29.svg";